import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { ListingAnalytics } from '@/types/car';
import { trackListingView } from '@/utils/contactTracking';

export const useAnalytics = (listingId?: string, dateRange?: { start: string; end: string }) => {
  const [analytics, setAnalytics] = useState<ListingAnalytics[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

    const fetchAnalytics = async () => {
      const { data: authData } = await supabase.auth.getUser();
      if (!authData?.user) {
        setError('Authentication required');
        return;
      }

    setLoading(true);
    setError(null);

    try {
      const { data, error } = await supabase.functions.invoke('get-listing-analytics', {
        body: {
          listingId,
          startDate: dateRange?.start,
          endDate: dateRange?.end
        }
      });

      if (error) throw error;

      setAnalytics(data.analytics || []);
    } catch (err) {
      console.error('Error fetching analytics:', err);
      setError(err instanceof Error ? err.message : 'Failed to fetch analytics');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAnalytics();
  }, [listingId, dateRange?.start, dateRange?.end]);

  return {
    analytics,
    loading,
    error,
    refetch: fetchAnalytics
  };
};

// Card / quick-view views go through the single consent-gated tracker (one per listing per tab).
export const useViewTracking = () => {
  const trackView = async (listingId: string, _providedSessionId?: string): Promise<boolean> =>
    trackListingView({ id: listingId });
  return { trackView };
};
